var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDartNo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 57C46.438 57 56 47.437 56 35.75c0-11.688-9.563-21.25-21.25-21.25-11.688 0-21.25 9.563-21.25 21.25C13.5 47.438 23.063 57 34.75 57zm0-40.375c10.625 0 19.125 8.5 19.125 19.125s-8.5 19.125-19.125 19.125A19.045 19.045 0 0115.625 35.75c0-10.625 8.5-19.125 19.125-19.125z",
    fill: "#1A3248",
    stroke: "#1A3248",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 49.563c7.65 0 13.813-6.163 13.813-13.813S42.4 21.937 34.75 21.937A13.785 13.785 0 0020.937 35.75c0 7.65 6.163 13.813 13.813 13.813zm0-25.5c6.375 0 11.688 5.312 11.688 11.687 0 6.375-5.313 11.688-11.688 11.688-6.375 0-11.688-5.313-11.688-11.688 0-6.375 5.313-11.688 11.688-11.688z",
    fill: "#1A3248",
    stroke: "#1A3248",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 36.813c.212 0 .637 0 .85-.213a1.027 1.027 0 000-1.487L19.661 19.175a1.027 1.027 0 00-1.488 0 1.027 1.027 0 000 1.488L34.112 36.6c0 .213.425.213.637.213z",
    fill: "#1A3248",
    stroke: "#1A3248",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.875h5.313c.637 0 1.062-.425 1.062-1.063V14.5c0-.213-.212-.637-.212-.85l-7.438-7.438C11.8 6 11.375 6 10.95 6a1.169 1.169 0 00-.637 1.063v4.25h-4.25c-.425 0-.85.212-1.063.637 0 .425 0 .85.213 1.275l7.437 7.438c.213 0 .637.212.85.212zm4.25-2.125h-3.825l-5.313-5.313h2.763c.637 0 1.063-.425 1.063-1.062V9.613l5.312 5.312v3.825zM31.068 41c-.194 0-.583 0-.777-.194a.938.938 0 010-1.36l8.156-8.155a.938.938 0 011.359 0 .938.938 0 010 1.36l-8.155 8.155c-.195.194-.389.194-.583.194z",
    fill: "#1A3248",
    stroke: "#1A3248",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.03 41c.194 0 .582 0 .776-.194a.939.939 0 000-1.36l-8.155-8.155a.939.939 0 00-1.36 0 .939.939 0 000 1.36l8.156 8.155c.194.194.389.194.583.194z",
    fill: "#1A3248",
    stroke: "#1A3248",
    strokeWidth: 1.5
  })));
}

export default SvgDartNo;